import * as React from 'react';
import IconBase, { IconBaseProps } from '../components/Icons/IconBase';
const props = {};

const SvgFire = (allProps: IconBaseProps) => {
  return (
    <IconBase {...allProps}>
      <svg
        width="1em"
        height="1em"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path
          d="M10.8333 10.4525C11.4059 11.1354 11.7553 11.9775 11.8342 12.8652C11.9132 13.7529 11.718 14.6434 11.275 15.4167C10.8827 15.447 10.4937 15.3272 10.1864 15.0815C9.87915 14.8358 9.67669 14.4826 9.61997 14.0933C9.03265 14.4143 8.54925 14.8963 8.22667 15.4827C7.90409 16.0691 7.75576 16.7355 7.79913 17.4033C7.79913 17.925 7.90189 18.4415 8.10154 18.9234C8.30119 19.4053 8.59381 19.8432 8.9627 20.212C9.3316 20.5808 9.76953 20.8734 10.2515 21.0729C10.7334 21.2725 11.25 21.3751 11.7716 21.375C12.8206 21.3608 13.8225 20.9378 14.5643 20.196C15.3061 19.4542 15.7291 18.4523 15.7433 17.4033C15.89 13.4858 13.615 11.3625 10.8333 10.4525Z"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M19.1808 7.62417H18.875L16.6817 10.3658C15.8504 7.83275 15.9569 5.08533 16.9817 2.62417C15.072 2.72095 13.2191 3.30648 11.6007 4.32467C9.98218 5.34287 8.65226 6.75961 7.73832 8.43917L5.74998 6.5C4.58763 7.68628 3.78689 9.17888 3.44135 10.8034C3.09581 12.4278 3.21973 14.1171 3.79864 15.6738C4.37755 17.2304 5.38753 18.5902 6.71055 19.5942C8.03358 20.5981 9.61502 21.2048 11.2701 21.3433C12.9251 21.4819 14.5854 21.1465 16.0569 20.3765C17.5284 19.6064 18.7504 18.4335 19.58 16.9947C20.4096 15.5559 20.8126 13.9107 20.742 12.2514C20.6713 10.5921 20.1298 8.98717 19.1808 7.62417V7.62417Z"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </IconBase>
  );
};

SvgFire.displayName = 'SvgFire';
export default SvgFire;
